import React, { useState } from 'react';
import { FiLock, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import { updatePassword } from '../../apis/adminAuth';
import './AdminProfile.scss';

const AdminProfile = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!oldPassword || !newPassword || !confirmNewPassword) {
            setError('Vui lòng nhập đầy đủ thông tin.');
            return;
        }

        if (newPassword !== confirmNewPassword) {
            setError('Mật khẩu xác nhận không khớp.');
            return;
        }

        if (newPassword.length < 6) {
            setError('Mật khẩu mới phải có ít nhất 6 ký tự.');
            return;
        }

        setLoading(true);
        try {
            const data = {
                oldPassword: oldPassword,
                newPassword: newPassword
            };
            const response = await updatePassword(data);
            
            if (response && response.success) {
                setSuccess(response.message || 'Cập nhật mật khẩu thành công.');
                setOldPassword('');
                setNewPassword('');
                setConfirmNewPassword('');
            } else {
                setError(response?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Có lỗi xảy ra khi cập nhật mật khẩu.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-profile-page">
            <div className="profile-header">
                <h2>Hồ Sơ Của Tôi</h2>
                <p>Quản lý thông tin tài khoản và bảo mật</p>
            </div>

            <div className="profile-content">
                <div className="profile-card">
                    <div className="card-header">
                        <h3>Đổi Mật Khẩu</h3>
                        <p>Cập nhật mật khẩu để bảo vệ tài khoản của bạn</p>
                    </div>

                    <div className="card-body">
                        {error && (
                            <div className="alert alert-error">
                                <FiAlertCircle className="icon" />
                                <span>{error}</span>
                            </div>
                        )}
                        {success && (
                            <div className="alert alert-success">
                                <FiCheckCircle className="icon" />
                                <span>{success}</span>
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className="password-form">
                            <div className="form-group">
                                <label>Mật khẩu hiện tại</label>
                                <div className="input-with-icon">
                                    <FiLock className="input-icon" />
                                    <input 
                                        type="password" 
                                        value={oldPassword}
                                        onChange={(e) => setOldPassword(e.target.value)}
                                        placeholder="Nhập mật khẩu hiện tại"
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Mật khẩu mới</label>
                                <div className="input-with-icon">
                                    <FiLock className="input-icon" />
                                    <input 
                                        type="password" 
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        placeholder="Nhập mật khẩu mới"
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Xác nhận mật khẩu mới</label>
                                <div className="input-with-icon">
                                    <FiLock className="input-icon" />
                                    <input 
                                        type="password" 
                                        value={confirmNewPassword}
                                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                                        placeholder="Nhập lại mật khẩu mới"
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                            <div className="form-actions">
                                <button type="submit" className="btn-save" disabled={loading}>
                                    {loading ? 'Đang xử lý...' : 'Cập Nhật Mật Khẩu'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminProfile;
